import { createFileRoute } from "@tanstack/react-router";
import { requireProOnboardingStart } from "@/lib/auth-guard";

export const Route = createFileRoute("/onboarding/start")({
  beforeLoad: requireProOnboardingStart,
});
